;(function($, window, document){
    window.CurbsidePopup = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this, 'addEvents', 'toggleInfos', 'hideInfos');

            this.addEvents();

        },
        addEvents: function() {
            this.$('.popup-info').on('click', this.toggleInfos);
            Me.dispatch.subscribe('close.curbsidePickup', this.hideInfos);
        },
        hideInfos: function(){
            this.$('.popup-infos').removeClass('active');
            this.$('.popup-infos').off('mouseleave', this.toggleInfos);
            this.$('.popup-infos').off('click', this.hideInfos);
        },
        toggleInfos: function(){

            if(this.$('.popup-infos').hasClass('active')){
                this.$('.popup-infos').removeClass('active');
                this.$('.popup-infos').off('mouseleave', this.toggleInfos);
                this.$('.popup-infos').off('click', this.hideInfos);
            }else{
                Me.dispatch.emit('close.pickupInStore');
                this.$('.popup-infos').on('click', this.hideInfos);
                this.$('.popup-infos').on('mouseleave', this.toggleInfos);
                this.$('.popup-infos').addClass('active');
            }
        }
    });
}(jQuery, window, document));